module.exports = __webpack_public_path__ + "img/menu.96b4dea6.svg";